import { takeLatest, call, put } from 'redux-saga/effects'
import {
    addDocumentAPI, documentDetailAPI, documentListAPI
} from '../api-requests/document';
import {
    addDocumentRequestError, addDocumentRequestSuccess, documentDetailRequestError,
    documentDetailRequestSuccess, documentListRequestError, documentListRequestSuccess
} from './document.action';
import { DocumentActionTypes } from './document.types'
import { displayConsoleLog } from '../../utils/Utils'
import { decryptResponseData } from '../../utils/DataDecryptionUtils';

function* handleDocumentList({ payload }) {
    try {
        const response = yield call(documentListAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(documentListRequestSuccess(decryptedData))
            } else {
                yield put(documentListRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(documentListRequestError(error.response.data))
    }
}

export function* documentListReq() {
    yield takeLatest(DocumentActionTypes.DOCUMENT_LIST_REQUEST, handleDocumentList)
}

function* handleDocumentDetail({ payload }) {
    try {
        const response = yield call(documentDetailAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(documentDetailRequestSuccess(decryptedData))
            } else {
                yield put(documentDetailRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(documentDetailRequestError(error.response.data))
    }
}

export function* documentDetailReq() {
    yield takeLatest(DocumentActionTypes.DOCUMENT_DETAIL_REQUEST, handleDocumentDetail)
}

function* handleAddDocument({ payload }) {
    try {
        const response = yield call(addDocumentAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(addDocumentRequestSuccess(decryptedData))
            } else {
                yield put(addDocumentRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(addDocumentRequestError(error.response.data))
    }
}

export function* addDocumentReq() {
    yield takeLatest(DocumentActionTypes.ADD_DOCUMENT_REQUEST, handleAddDocument)
}